export default "__VITE_ASSET__B$DEe8XL__"